import React, { useState } from "react";
import { Header } from "../../../components/page-header/Header";
import {
  Layout,
  Palette,
  PlayCircle,
  ImageIcon,
  Bell,
  Clock,
  Plus,
  ChevronRight,
  Save,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import DisplayView from "./display-view";
import PlaylistView from "./playlist-view";
import {
  useAddDisplayMutation,
  useGetdisplayQuery,
} from "../../../store/Reducer/display";

const MasjidDisplay = () => {
  const { t } = useTranslation();

  const [isPlaylist, setIsPlayList] = useState(false);
  const [deviceId, setDeviceId] = useState("");

  // const [layout, setLayout] = useState('horizontal');
  // const [selectedColor, setSelectedColor] = useState('blue');
  // const [playlistItems, setPlaylistItems] = useState([
  //     { type: 'prayer', duration: 15, title: 'Next Prayer Times' },
  //     { type: 'image', duration: 10, title: 'Masjid Image' },
  //     { type: 'announcement', duration: 30, title: 'Community Announcement' }
  // ]);

  // const colorSchemes = [
  //     { name: 'blue', primary: 'bg-blue-500', secondary: 'bg-blue-100' },
  //     { name: 'green', primary: 'bg-green-500', secondary: 'bg-green-100' },
  //     { name: 'purple', primary: 'bg-purple-500', secondary: 'bg-purple-100' },
  //     { name: 'teal', primary: 'bg-teal-500', secondary: 'bg-teal-100' }
  // ];

  // const getIconForType = (type) => {
  //     switch (type) {
  //         case 'prayer':
  //             return <Clock className="w-5 h-5" />;
  //         case 'image':
  //             return <ImageIcon className="w-5 h-5" />;
  //         case 'announcement':
  //             return <Bell className="w-5 h-5" />;
  //         default:
  //             return null;
  //     }
  // };

  const breadcrumbItems = [
    { label: t("universal_dashboard_text"), to: "/user-dashboard" },
    { label: t("masjidDisplayTitle") },
  ];

  return (
    <section className="min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
      <div className="max-w-7xl mx-auto p-4 sm:p-6 space-y-5">
        <div className="flex items-center justify-between">
          <Header
            title={t("masjidDisplayTitle")}
            breadcrumbItems={breadcrumbItems}
          />
        </div>

        <DisplayView
          isPlaylist={isPlaylist}
          setIsPlayList={setIsPlayList}
          setDeviceId={setDeviceId}
        />
        <PlaylistView
          isPlaylist={isPlaylist}
          setIsPlayList={setIsPlayList}
          deviceId={deviceId}
        />    



        

        {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="lg:col-span-1 space-y-6">
                        <div className="bg-white rounded-xl shadow-sm p-6">
                            <h2 className="text-xl font-semibold mb-6 flex items-center gap-2">
                                <Layout className="w-5 h-5 text-blue-500" />
                                {t("TemplateSettingsText")}
                            </h2>

                            <div className="space-y-4">
                                <h3 className="text-sm font-medium text-gray-700">{t("LayoutText")}</h3>
                                <div className="grid grid-cols-2 gap-4">
                                    <button
                                        onClick={() => setLayout('horizontal')}
                                        className={`p-4 rounded-lg border-2 transition-all ${layout === 'horizontal'
                                            ? 'border-blue-500 bg-blue-50'
                                            : 'border-gray-200 hover:border-blue-200'
                                            }`}
                                    >
                                        <div className="w-full h-8 bg-gray-200 rounded mb-2"></div>
                                        <span className="text-sm font-medium">{t("HorizontalText")}</span>
                                    </button>
                                    <button
                                        onClick={() => setLayout('vertical')}
                                        className={`p-4 rounded-lg border-2 transition-all ${layout === 'vertical'
                                            ? 'border-blue-500 bg-blue-50'
                                            : 'border-gray-200 hover:border-blue-200'
                                            }`}
                                    >
                                        <div className="w-8 h-16 bg-gray-200 rounded mb-2 mx-auto"></div>
                                        <span className="text-sm font-medium">{t("VerticalText")}</span>
                                    </button>
                                </div>
                            </div>

                            <div className="mt-8">
                                <h3 className="text-sm font-medium text-gray-700 mb-4 flex items-center gap-2">
                                    <Palette className="w-4 h-4 text-blue-500" />
                                    {t("ColorSchemesText")}
                                </h3>
                                <div className="grid grid-cols-2 gap-4">
                                    {colorSchemes.map((scheme) => (
                                        <button
                                            key={scheme.name}
                                            onClick={() => setSelectedColor(scheme.name)}
                                            className={`p-4 rounded-lg border-2 transition-all ${selectedColor === scheme.name
                                                ? 'border-blue-500'
                                                : 'border-gray-200 hover:border-blue-200'
                                                }`}
                                        >
                                            <div className={`w-full h-8 ${scheme.primary} rounded mb-2`}></div>
                                            <div className={`w-1/2 h-4 ${scheme.secondary} rounded`}></div>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-2 space-y-6">
                        <div className="bg-white rounded-xl shadow-sm p-6">
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-xl font-semibold flex items-center gap-2">
                                    <PlayCircle className="w-5 h-5 text-blue-500" />
                                    {t("PlaylistText")}
                                </h2>
                                <button className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2">
                                    <Plus className="w-4 h-4" />
                                    {t("CreatePlaylistButtonText")}
                                </button>
                            </div>

                            <div className="space-y-4">
                                {playlistItems.map((item, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors group"
                                    >
                                        <div className={`p-3 rounded-lg ${colorSchemes.find(c => c.name === selectedColor).secondary}`}>
                                            {getIconForType(item.type)}
                                        </div>
                                        <div className="flex-grow">
                                            <h3 className="font-medium">{item.title}</h3>
                                            <p className="text-sm text-gray-500">Duration: {item.duration} seconds</p>
                                        </div>
                                        <button className="opacity-0 group-hover:opacity-100 transition-opacity">
                                            <ChevronRight className="w-5 h-5 text-gray-400" />
                                        </button>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-8 flex justify-end">
                                <button className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2">
                                    <Save className="w-4 h-4" />
                                    {t("SaveChangesButtonText")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div> */}
      </div>
    </section>
  );
};

export default MasjidDisplay;
